import { almaCareerProvider } from './providers/alma-career';
import type { CookieConsentProvider } from './types';

/**
 * Cookie consent. GTM loads on every visit and receives the visitor's choice
 * through Consent Mode (`consent-mode.ts`); the container decides per tag what
 * may run.
 */
const provider: CookieConsentProvider = almaCareerProvider;

/** Initializes the banner in the fair's language. Later calls are ignored. */
export function initCookieConsent(language: string): void {
  provider.init(language);
}

/** Reopens the preferences modal, e.g. from the footer's cookie settings link. */
export function showCookiePreferences(): void {
  provider.showPreferences();
}

export function isAnalyticsConsentGiven(): boolean {
  return provider.isAnalyticsConsentGiven();
}

/**
 * Waits for the cookie banner to be settled, so a popup does not open on top
 * of it. Runs at once when the visitor already made a choice.
 */
export function onConsentGiven(callback: () => void): () => void {
  return provider.onConsentGiven(callback);
}
